import { Text, View, ViewProps } from "react-native";
import { useNavigate } from "react-router-dom";

import { ReactComponent as StepPreviousNormal } from '../../../img/ico-step-previous-normal.svg';
import { FONT } from "../../../value/staticValues";
import { AlertBoxContent } from "./AlartContent";

interface ContentBoxProps extends ViewProps {
    title: string;
    subtitle?: string;
    back?: boolean;
    infoText: string;
    infoError?: boolean;
}

export default function ContentBox(props:ContentBoxProps) {
    const navigate = useNavigate();
    
    function pageBackMove() {
        navigate(-1);
    }

    return (
        <div style={{
            display: "flex", flexDirection: "column",
            flex: 1, height: "100%",
            marginLeft: 20, marginTop: 16,
            paddingTop: 10, paddingLeft: 60, paddingRight: 40, paddingBottom: 30,
            borderTopLeftRadius: 30, borderBottomLeftRadius: 30,
            boxShadow: "0 10px 12px 0 rgba(79, 95, 216, 0.3)",
            backgroundColor: "#fff",
        }}>

            <AlertBoxContent
                text={props.infoText}
                error={props.infoError}
            />
            <View style={{
                flexDirection: "row", alignItems: "center",
            }}>
                {props.back ? 
                    <StepPreviousNormal 
                        style={{marginRight: 11, cursor:"pointer"}}
                        onClick={pageBackMove}
                    /> 
                : null }
                <View style={{
                    flexDirection: "row", alignItems: "flex-end"
                }}>
                    <Text style={{
                        marginRight: 20,
                        fontFamily: FONT.MEDIUM,
                        fontSize: 18,
                        lineHeight: 24,
                        color: "#252525"
                    }}>
                        {props.title}
                    </Text>
                    {props.subtitle? 
                        <Text style={{
                            fontFamily: FONT.REGULAR,
                            fontSize: 12,
                            lineHeight: 20,
                            color: "#8c9299"
                        }}>
                            {props.subtitle}
                        </Text>
                    : null}
                </View>
            </View>
            <div id="networkTopologyContent" style={{flexGrow:1}}>
                <View style={{
                    marginTop: 20, marginRight: 10, marginBottom: 18
                }}>
                    {props.children}
                </View>
            </div>
            <View style={{bottom:0}}>
                <Text style={{
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#b6bfce",
                    textAlign: "right"
                }}>
                    {/* copyright (34129) 대전광역시 유성구 가정로 218, TEL 1466-38<br/>Electronics and Telecommunications Research Institute. All rights reserved. */}
                    Copyright ⓒ GlooVir Inc. All rights reserved.
                </Text>
            </View>
        </div>
    )
}